module.exports = __webpack_public_path__ + "img/bg-sect-1.e97b663f.png";